export function normalizarTexto(str) {
	if (str == null || str === '') return ''
	return String(str)
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.trim()
}

export function chaveResultado(item) {
	return `${item.id}-${item.ponto}`
}

export function mesclarResultados(local = [], api = []) {
	const mapa = new Map()

	for (const item of [...local, ...api]) {
		const chave = chaveResultado(item)
		const existente = mapa.get(chave)

		if (!existente) {
			mapa.set(chave, item)
			continue
		}

		if (item.tipoMatch === 'numeroNota' && existente.tipoMatch !== 'numeroNota') {
			mapa.set(chave, { ...existente, ...item, tipoMatch: 'numeroNota' })
		}
	}

	return Array.from(mapa.values())
}

export function buscarServicosLocal(servicos, termo) {
	const termoNorm = normalizarTexto(termo)
	if (!termoNorm || !Array.isArray(servicos) || servicos.length === 0) return []

	const resultados = []

	for (const servico of servicos) {
		const id = servico['s.id']
		const camposServico = [
			id,
			servico['s.numeroPedido'],
			servico['so.nome'],
			servico['so.empresa'],
			servico['s.nomeSolicitante'],
		]

		const enderecos = servico.enderecos ?? []

		if (enderecos.length === 0) {
			if (camposServico.some((c) => normalizarTexto(c).includes(termoNorm))) {
				resultados.push({
					id,
					codigo: id,
					numeroNota: '',
					numeroPedido: servico['s.numeroPedido'] ?? '',
					ponto: 0,
					endereco: '',
					tipoMatch: 'local',
				})
			}
			continue
		}

		for (const end of enderecos) {
			const camposEndereco = [
				...camposServico,
				end['e.rua'],
				end['e.responsavel'],
				end['e.bairro'],
				end['e.cidade'],
			]

			if (!camposEndereco.some((c) => normalizarTexto(c).includes(termoNorm))) continue

			resultados.push({
				id,
				codigo: id,
				numeroNota: '',
				numeroPedido: servico['s.numeroPedido'] ?? '',
				ponto: end['es.ponto'] ?? 0,
				endereco: end['e.rua'] ?? '',
				tipoMatch: 'local',
			})
		}
	}

	return resultados
}
